import React from "react"
import SvgIcon from "@material-ui/core/SvgIcon"

export default function MongoDbIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 30 65">
      <g transform="translate(14.1253 0.1748)">
        <path
          d="M 0.0487 0 L 1.7567 3.2079 C 2.1407 3.7999 2.5567 4.3240 3.0467 4.8120 C 4.4767 6.2419 5.8347 7.7400 7.0547 9.3440 C 9.9487 13.1439 11.9007 17.3640 13.2947 21.9279 C 14.1307 24.7160 14.5847 27.5760 14.6187 30.4680 C 14.7587 39.1140 11.7947 46.5380 5.8187 52.7079 C 4.8427 53.6840 3.7987 54.5880 2.6787 55.3920 C 2.0867 55.3920 1.8067 54.9380 1.5627 54.5200 C 1.1087 53.7540 0.8307 52.8799 0.6907 52.0100 C 0.4807 50.9640 0.3427 49.9180 0.4107 48.8379 L 0.4107 48.3500 C 0.3627 48.2460 -0.1592 0.2459 0.0487 0 Z"
          strokeWidth={2}
          fillOpacity={1}
        />
      </g>
      <g>
        <path
          d="M 14.1741 0.0688 C 14.1041 -0.0711 14.0341 0.0348 13.9641 0.1028 C 13.9981 0.8028 13.7541 1.4268 13.3721 2.0228 C 12.9521 2.6148 12.3961 3.0688 11.8381 3.5568 C 8.7381 6.2408 6.2981 9.4828 4.3441 13.1088 C 1.7441 17.9888 0.4041 23.2188 0.0241 28.7248 C -0.1498 30.7108 0.6521 37.7187 1.2781 39.7408 C 2.9861 45.1088 6.0541 49.6067 10.0281 53.5108 C 11.0041 54.4508 12.0481 55.3227 13.1281 56.1608 C 13.4421 56.1608 13.4761 55.8808 13.5481 55.6728 C 13.6857 55.2277 13.7907 54.7731 13.8621 54.3128 L 14.5621 49.0848 Z"
          fill="none"
          strokeWidth={2}
          strokeOpacity={1}
          stroke="#fff"
        />
      </g>
      <g transform="translate(13.1281 48.1068)">
        <path
          d="M 2.7540 9.5839 C 2.8240 8.7840 3.2080 8.1199 3.6260 7.4580 C 3.2060 7.2839 2.8940 6.9379 2.6500 6.5520 C 2.4400 6.2040 2.2660 5.7859 2.1300 5.4019 C 1.6420 3.9379 1.5380 2.4019 1.3980 0.9059 L 1.3980 0 C 1.2240 0.1399 1.1880 1.3239 1.1880 1.4999 C 1.0862 3.0811 0.8764 4.6534 0.5600 6.2059 C 0.4560 6.8339 0.3860 7.4600 0 8.0180 C 0 8.0879 0 8.1579 0.0340 8.2619 C 0.6620 10.1100 0.8340 11.9919 0.9400 13.9099 L 0.9400 14.6099 C 0.9400 15.4459 0.9060 15.2700 1.6000 15.5499 C 1.8800 15.6539 2.1920 15.6899 2.4720 15.8979 C 2.6820 15.8979 2.7160 15.7240 2.7160 15.5839 L 2.6120 14.4339 L 2.6120 11.2259 C 2.5780 10.6659 2.6820 10.1100 2.7520 9.5859 Z"
          strokeWidth={2}
          strokeOpacity={1}
          fillOpacity={1}
        />
      </g>
    </SvgIcon>
  )
}
